module.exports = __webpack_public_path__ + "static/media/bell.5d99cda7.png";